import {Language, DigitalDownload} from "../langage/Language";
import { LANGUAGE_UPDATE } from "../actions/Consts";

const initialState = {...Language,...DigitalDownload}

export default (state = initialState, { type, payload }) => {
    switch (type) {
    case LANGUAGE_UPDATE:
        return { ...state, ...payload }
    default:
        return state
    }
}
